import { Theme, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    backgroundColor: theme.palette.grey[50],
  },
  outer: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: theme.spacing(0, 4, 6),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 3, 4),
    },
  },
  note: {
    textAlign: 'end',
    padding: theme.spacing(1.5, 2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.75, 0),
    },
  },
  withoutNote: {
    padding: theme.spacing(6, 0, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 0, 0),
    },
  },
  inner: {
    margin: '0 auto 0 0',
  },
  tooltipIcon: {
    verticalAlign: 'text-bottom',
    height: 17,
    color: theme.palette.grey[300],
  },
  tooltip: {
    background: theme.palette.grey[800],
    maxWidth: 225,
    padding: theme.spacing(1),
  },
  tooltipArrow: {
    color: theme.palette.grey[800],
  },
  tooltipTypography: {
    color: theme.palette.grey[100],
  },
}));
